import { Title } from "../../Atoms/Title";
import { FormClientEdit } from "../../Molecules/FormClientEdit";
import * as S from "./styles";
import { useClientDetail } from "./useClientDetail";

export const ClientDetailTemplate = () => {
  const { submitForm } = useClientDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Cliente</Title>
        <FormClientEdit submitForm={submitForm} />
      </S.Wrapper>
    </S.Container>
  );
};
